// Unpublished Work © 2023-2024 Deere & Company.

export const DANGER = 'danger';
export const OK = 'ok';
export const WARNING = 'warning';
